var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 64,
    width: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "remote") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 4,
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    className: "nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35,62H13a5,5,0,0,1-5-5V23a5,5,0,0,1,5-5H35a5,5,0,0,1,5,5V57A5,5,0,0,1,35,62Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,20A10,10,0,0,0,38,10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56,20A18,18,0,0,0,38,2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 24,
    width: 20,
    height: 29
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemote);
export default __webpack_public_path__ + "static/media/remote.8f67d3c4b84c8110b5533aa3a4b3918d.svg";
export { ForwardRef as ReactComponent };